import axios from 'axios';
import React, { Fragment, useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setSnackbar } from '../../../../../components/hooks/snackBar/reducers';
import { Helmet } from 'react-helmet-async';
import { Autocomplete, Button, Grid, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from '@mui/material';
import { useStyle } from '../style';
import _ from 'lodash';
import Loader from '../../../../../components/loader/loader';
import { Delete } from '@mui/icons-material';
import moment from 'moment';
import { setPDFData } from '../../../../../components/hooks/printPdf/pdfData';
import { useNavigate } from 'react-router-dom';
import { onPressButton, setThermalData } from '../../../../../components/hooks/printPdf/thermalData';

const OtToOtTransfer = () => {
    const classes = useStyle()
    const navigate = useNavigate()
    const dispatch = useDispatch();
    const [data, setData] = useState([]);
    const [outlet, setOutlet] = useState([]);
    const [code, setCode] = useState("");
    const codeRef = useRef(null);
    const [endCode, setEndCode] = useState('')
    const [itemData, setItemData] = useState(null)
    const[cust, setCust] = useState(null)
    const roleId = localStorage.getItem("role_id")

    const outlet_id = localStorage.getItem('outlet_id')
    const userID = localStorage.getItem('userId')
    const [editingIndex, setEditingIndex] = useState(null);
    const [isLoader, setIsLoader] = useState(false); //loader
    const [options, setOptions] = useState({
        fromOutlet: null,
        toOutlet: null
    });
    const [postData, setPostData] = useState({
        docdate: moment().format('YYYY-MM-DD'),
        status: "",
        user_id: userID,
        outletid: outlet_id,
        amount: "",
        subtotal_amount: "",
        gst_per: 0,
        gst_amt: "",
        cess_per: 0,
        cess_amt: "",
        roff: "",
        is_credit: 1,
        company_id: 1,
        gst_in: "",
        outlet_to_outlet_details: [],
      });
      let totalAmt=0
      totalAmt += data.reduce((accumulator, item) => accumulator + parseFloat(item.totalAmt), 0);
      let gstAmt=0
      gstAmt += data.reduce((accumulator, item) => accumulator + parseFloat(item.gstAmt), 0);
      let cessAmt=0
      cessAmt += data.reduce((accumulator, item) => accumulator + parseFloat(item.cessAmt), 0);
      let netTotal = 0
      // netTotal = parseFloat(totalAmt + gstAmt + cessAmt).toFixed(2)
      netTotal = parseFloat(totalAmt + gstAmt ).toFixed(2)
    // function getOutletData() {
    //     axios
    //         .get("/v1/outlet/list/1")
    //         .then((res) => {
    //             setOutlet(res.data);
    //         })
    //         .catch((err) => {
    //             dispatch(setSnackbar(true, "error", err.response.data.error));
    //         });
    // }
    const outletName = localStorage.getItem('outlet_name');

    const filteredSupplier = outlet.filter(outlet => outlet.fullname === outletName);

    const units = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
    const teens = ['Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
    const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
    const thousands = ['', 'Thousand', 'Million', 'Billion', 'Trillion'];
  
    const convertNumber = (num) => {
      if (num === 0) return 'Zero';
  
      let words = '';
      for (let i = 0; num > 0; i++) {
        if (num % 1000 !== 0) {
          words = convertHundreds(num % 1000) + ' ' + thousands[i] + ' ' + words;
        }
        num = Math.floor(num / 1000);
      }
      return words.trim();
    };
  
    const convertHundreds = (num) => {
      if (num >= 100) {
        return units[Math.floor(num / 100)] + ' Hundred ' + convertTens(num % 100);
      } else {
        return convertTens(num);
      }
    };
  
    const convertTens = (num) => {
      if (num < 10) return units[num];
      else if (num < 20) return teens[num - 10];
      else return tens[Math.floor(num / 10)] + ' ' + units[num % 10];
    };
    function getOutletData() {
        axios
            .get("/v1/outlet/list/1")
            .then((res) => {
                setOutlet(res.data);
    
                // Find and prefill the outlet matching the logged-in branch
                const loggedInOutlet = res.data.find((outlet) => outlet.id === parseInt(outlet_id));
                if (loggedInOutlet) {
                    setOptions((prevOptions) => ({
                        ...prevOptions,
                        fromOutlet: loggedInOutlet,
                    }));
                    setCust(loggedInOutlet); // Set the customer info if needed
                }
            })
            .catch((err) => {
                dispatch(setSnackbar(true, "error", err.response.data.error));
            });
    }
    
    function handleOptions(value, name) {
        let newOptions = { ...options, [name]: value };

        if (newOptions.fromOutlet && newOptions.toOutlet && newOptions.fromOutlet.id === newOptions.toOutlet.id) {
            newOptions = { ...newOptions, toOutlet: null };
        }

        setOptions(newOptions);
        console.log(name, value);
    }
    function getSelectedRow(e){
        setEditingIndex(e)
       } 
       const handleDeleteRow=(e, index)=>{
          console.log(e,index)
          const updatedData = data.filter((_, i) => i !== index);
          setData(updatedData);
      }
      const handleCodeChange = (e) =>{
        // setCode(e.target.value)
        setCode(e.target.value.toUpperCase());

    }
    const getItemCode = (id) =>{
        setIsLoader(true)
        axios.get(`/v1/itemdetails/barcode/${id}/${outlet_id}`)
        .then(res=>{
          setIsLoader(false)
          setItemData(res.data)
          setEndCode(id)
          // setRateData((prevData) => ({ ...prevData, mrp: res.data.mrp, rate: res.data.sale_rate, gst : res.data.gst, disc : res.data.discount, qty: 1 }));
          const objData = {
            code: code,
            barcode_to : id,
            qty: 1,
            mrp1: res.data.mrp,
            pro_name: res.data.pro_name,
            rate1: res.data.sale_rate,
            gst1: res.data.gst,
            disc1: res.data.discount,
            gstAmt:parseFloat((res.data.sale_rate - res.data.sale_rate * res.data.discount / 100) * (res.data.gst / 100) * 1).toFixed(2),
            // gstAmt:parseFloat((res.data.mrp - res.data.mrp * res.data.discount / 100) * (res.data.gst / 100) * 1).toFixed(2),
            cessAmt: parseFloat((res.data.sale_rate - res.data.sale_rate * res.data.discount / 100) * (res.data.cess / 100) * 1).toFixed(2),
            totalAmt: parseFloat((res.data.sale_rate - res.data.sale_rate * res.data.discount / 100) * 1).toFixed(2),
            ...res.data
        }
        const existingItemIndex = data.findIndex((item) => item.code === objData.code && (item.mrp1 === objData.mrp || item.mrp1 === objData.mrp1));
        const arr = [...data]       
        setData([])
        setCode("")
        if (existingItemIndex !== -1) {
        // If the item exists, update its quantity, gst, cess, total
          // arr[existingItemIndex].qty = parseFloat(arr[existingItemIndex].qty) + parseFloat(objData.qty);    
          // arr[existingItemIndex].barcode_to = parseFloat(arr[existingItemIndex].barcode_to ) + parseFloat(objData.qty)
          // arr[existingItemIndex].gstAmt = (parseFloat(arr[existingItemIndex].rate1)-parseFloat(arr[existingItemIndex].rate1) * parseFloat(arr[existingItemIndex].disc1 / 100)) * (parseFloat(arr[existingItemIndex].gst1  / 100))* parseFloat(arr[existingItemIndex].qty);    
          // arr[existingItemIndex].cessAmt = (parseFloat(arr[existingItemIndex].rate1)-parseFloat(arr[existingItemIndex].rate1) * parseFloat(arr[existingItemIndex].disc1 / 100)) * (parseFloat(arr[existingItemIndex].cess / 100))* parseFloat(arr[existingItemIndex].qty);    
          // arr[existingItemIndex].totalAmt = (parseFloat(arr[existingItemIndex].rate1)-parseFloat(arr[existingItemIndex].rate1) * parseFloat(arr[existingItemIndex].disc1 / 100)) * parseFloat(arr[existingItemIndex].qty);  
          dispatch(setSnackbar(true, 'error', 'Barcode already exists!'))
          setData(arr)
          
        } else {
        // If the item doesn't exist, add it to the 'data' array
          arr.push(objData)
          setData(arr)
          setCode("")
        }
        codeRef.current.focus()
        })
        .catch(err=>{
          setIsLoader(false)
          setCode("")

          console.log(err.response.data.errors[0].message)
          dispatch(setSnackbar(true , "error" ,err.response.data.errors[0].message ))
        })
      }
      const clearNew = () =>{
        console.log("first")
      }
    const handleCodeKeyPress = (e) =>{
        if(e.key === "Enter" && code!==''){
            getItemCode(code)
        }
    }
    useEffect(() => {
        getOutletData();
    }, []);

    const filteredToOutletOptions = outlet.filter(o => o.id !== (options.fromOutlet ? options.fromOutlet.id : null));
// const onSubmit = () => {
//     if(options.fromOutlet == null ){
//         dispatch(setSnackbar(true , "error" , "Please Select From outlet "))
//     }else if(options.toOutlet == null){
//         dispatch(setSnackbar(true , "error" , "Please Select To outlet "))
//     }else if(data.length == 0){
//         dispatch(setSnackbar(true , "error" , "Please Scan the barcode in table"))
//     }else{
//         console.log("postData",postData)
//         axios.post(`/v1/outlet_to_outlet_transfer` , postData)
//         .then((res) => {
//             console.log(res)
//             dispatch(setSnackbar(true,'success', 'Outlet transfer successfully!'))
//             fetchBill()
//             setData([])
//             setOptions((prev) => ({...prev , fromOutlet:null , toOutlet:null}))
//         })
//         .catch((err) => {
//             console.log(err)
//             dispatch(setSnackbar(true , "error" , err.response.data.errors[0].message))
//         })
//     }
// }

const onSubmit = () => {
  if (options.fromOutlet == null) {
      dispatch(setSnackbar(true, "error", "Please Select From outlet"));
  } else if (options.toOutlet == null) {
      dispatch(setSnackbar(true, "error", "Please Select To outlet"));
  } else if (data.length == 0) {
      dispatch(setSnackbar(true, "error", "Please Scan the barcode in table"));
  } else {
      console.log("postData", postData);
      axios.post(`/v1/outlet_to_outlet_transfer`, postData)
          .then((res) => {
              console.log(res);
              const { docno } = res.data; // Extract docno from the response
              // dispatch(setSnackbar(true, 'success', 'Outlet transfer successfully!'));
              fetchBill(docno); // Pass the docno to fetchBill
              setData([]);
              setOptions((prev) => ({ ...prev, fromOutlet: null, toOutlet: null }));
          })
          .catch((err) => {
              console.log(err);
              dispatch(setSnackbar(true, "error", err.response.data.errors[0].message));
          });
  }
};

function fetchBill(docno) {
  // axios.post(`/v1/outlet_to_outlet_transfer/getall`, { "docno": docno })
  axios.post('/v1/outlet_to_outlet_transfer/getall', { "docno": docno }, {
    headers: {
        'Content-Type': 'application/json'
    }
})
      .then((res) => {
          console.log(res);
          dispatch(setThermalData({
              tableData: tableData,
              TotalData: TotalData,
              companyInfo: res.data,
              docno:docno,
              
              totalText: convertNumber(Math.round(netTotal)),
              // title: postData.mode === "Transfer" ? "Delivery Challan" : "Outlet Transfer Report"
       
            }));
                    dispatch(onPressButton());
            
          const name = `BillNo_${docno}`;
          console.log(`Navigating to: /otTransfer/${name}`,"otTransferotTransfer");
          navigate(`/otTransfer/${name}`);
          
          console.log(docno,"dsdfwaefrwname");
          
      })
      .catch((err) => {
          console.log(err);
          dispatch(setSnackbar(true, 'error', err.response.data.errors[0].message));
      });
}

const tableData = data.map(val=>({
    pro_name: val.pro_name,
    hsn:val.hsn,
    sale_rate:val.sale_rate,
    pur_rate:val.pur_rate,
    qty:val.qty,
    disc1:val.disc1,
    cgstPerc:val.gst,
    cgstAmnt : val.gstAmt,
    totalAmt:val.totalAmt,
   mode:val.mode,
   barcode:val.barcode,
   pro_code:val.pro_code,
   
  }))
  console.log(data,"datacheck")
  console.log(postData,"postdata")
  const TotalData = {
    // cess_amt:cessAmt,
    sub_total: totalAmt,
    gst:gstAmt,
    totalAmount:parseFloat(Math.round(netTotal)).toFixed(0),
    roundOff:(parseFloat(Math.round(netTotal).toFixed(0) -netTotal).toFixed(0)),
    totalText : convertNumber(Math.round(netTotal)),
  }
  console.log(TotalData,"TotalData");
  
  // function fetchBill(){
  //   axios.post(`/v1/sales_master/getall`,{"docno":docName})
  //   .then((res) => {
  //     console.log(res);
  //       dispatch(setPDFData({
  //         tableData:tableData,
  //         TotalData:TotalData,
  //         companyInfo:res.data,  
  //         totalText : convertNumber(Math.round(netTotal)),
  //         title : postData.mode === "Transfer" ? "Delivery Challan" : "Outlet Transfer Report"
  //       }))
  //       const name = `BillNo_${docName}`
  //      navigate(`/otTransfer/${name}`)  
      
  //   })
  //   .catch((err) => {console.log(err);dispatch(setSnackbar(true,'error',err.response.data.errors[0].message))})
  // }


useEffect(() => {
    if(data.length > 0){
      let arr=[]
      data.map(val=>{
        const obj = {
          docdate:moment().format('YYYY-MM-DD'),
          from_outlet_id:options.fromOutlet != null ? options.fromOutlet.id :null,
          to_outlet_id:options.toOutlet != null ? options.toOutlet.id : null,
          pro_code:val.pro_code,
          balance:val.balance,
          opng_stock:val.op_stk,
          balnc_stock:1,
          prodid:val.id,
          dis_per:val.disc1,
          dis_amt:parseFloat((val.rate1 -(val.rate1 * (100 - val.disc1 )/ 100)) * val.qty).toFixed(2),
          mrp:val.mrp1,
          rate:val.rate1,
          qty:val.qty,
          gst_per:val.gst1,
          gst_amt:val.gstAmt,
          cess_per:val.cess,
          cess_amt:val.cessAmt,
          company_id:1,
          barcode:  val.barcode,
          head_id: val.head_id ,
          type_id:  val.type ,
          subcat_id:  val.sub_cat ,
          cat_id:  val.cat_id ,
          uom_id:  val.uom ,
          outletid: outlet_id
        }
        arr.push(obj)
      })
      setPostData((prevState)=>({...prevState,outlet_to_outlet_details: arr ,
        from_outlet_id:options.fromOutlet != null ? options.fromOutlet.id : null,
        to_outlet_id: options.toOutlet != null ? options.toOutlet.id : null,
        amount: Math.round(parseFloat(netTotal)),
        subtotal_amount:totalAmt ,
        gst_amt:parseFloat(gstAmt).toFixed(2),
        cess_amt:cessAmt,
        roff:(Math.round(netTotal).toFixed(2) -netTotal),
    }))
    }
      
    },[data,options])
    console.log('From Outlet:', options.fromOutlet);
    console.log('To Outlet:', options.toOutlet);
    console.log(data)
    console.log(postData)
    return (
        <Fragment>
            <Helmet><title>OT to OT Transfer</title></Helmet>
            <Typography variant="h6">OT to OT Transfer</Typography>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={4}>
                    <Typography sx={{ marginBlockEnd: "20px", fontWeight: "bold" }}>From Outlet</Typography>
                    {roleId == 2 || roleId == 1 ? 
                    
                    <Autocomplete
                    size="small"
                    value={options.fromOutlet}
                   
                    options={outlet}
                    // options={filteredSupplier} 

                    disableClearable
                    onChange={(e, value) => handleOptions(value, 'fromOutlet')}
                    getOptionLabel={option => option.fullname}
                    renderInput={(params) => <TextField {...params} label="Select Outlet" />}
                    isOptionEqualToValue={(option, value) => option.id === value.id} 
                />
                    
                    :
                    
                    <Autocomplete
                    size="small"
                    value={options.fromOutlet}
                   
                    // options={outlet}
                    options={filteredSupplier} 

                    disableClearable
                    onChange={(e, value) => handleOptions(value, 'fromOutlet')}
                    getOptionLabel={option => option.fullname}
                    renderInput={(params) => <TextField {...params} label="Select Outlet" />}
                    isOptionEqualToValue={(option, value) => option.id === value.id} 
                />
                    
                    }
                
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <Typography sx={{ marginBlockEnd: "20px", fontWeight: "bold" }}>To Outlet</Typography>
                    <Autocomplete
                        size="small"
                        value={options.toOutlet}
                        options={filteredToOutletOptions}
                        disableClearable
                        onChange={(e, value) => handleOptions(value, 'toOutlet')}
                        getOptionLabel={option => option.fullname}
                        renderInput={(params) => <TextField {...params} label="Select Outlet" />}
                        disabled={!options.fromOutlet} 
                        isOptionEqualToValue={(option, value) => option.id === value.id} 
                    />
                </Grid>
            </Grid>
            <Grid className="w-full " sx={{height:"350px",overflow:"auto",marginTop:"30px"}}>
                <TableContainer className={classes.tblRoot}>
                    <Table stickyHeader  className={classes.table}>
                    <TableHead className={classes.tblHeader} sx={{position: "sticky",top: 0,zIndex: 1}}>
                        <TableRow className={classes.tablrow}>
                        <TableCell className={classes.tblCell} sx={{borderLeft:'0.5px solid  #ccc'}}>Sno</TableCell>
                        <TableCell className={classes.tblCell} sx={{minWidth:"150px"}}>Barcode</TableCell>
                        <TableCell className={classes.tblCell} sx={{minWidth:"150px"}}>Product Name</TableCell>
                        <TableCell className={classes.tblCell}>MRP</TableCell>
                        <TableCell className={classes.tblCell}>GST%</TableCell>
                        <TableCell className={classes.tblCell}>Rate</TableCell>
                        <TableCell className={classes.tblCell}>Dis%</TableCell>
                        <TableCell className={classes.tblCell}>Qty</TableCell>
                        <TableCell className={classes.tblCell}>GST</TableCell>
                        <TableCell className={classes.tblCell}>Amount</TableCell>
                        <TableCell className={classes.tblCell}>Action</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {_.map(data, (val, index) => (
                        <TableRow className={classes.tablrow} key={index} onClick={() => getSelectedRow(index)}>
                        <TableCell  padding="checkbox" className={classes.tblContentCell} sx={{borderLeft:'0.5px solid  #ccc'}}>{index + 1}</TableCell>
                        <TableCell>{val.code}</TableCell>
                        <TableCell variant="body" className={classes.tblContentCell}>{val.pro_name}</TableCell>
                        <TableCell padding="checkbox" className={classes.tblContentCell} sx={{width:100}}>{val.mrp1}</TableCell>
                        <TableCell padding="checkbox"  className={classes.tblContentCell} sx={{width:100}}>{val.gst1}</TableCell>
                        <TableCell padding="checkbox"  className={classes.tblContentCell} sx={{width:100}}>{val.rate1}</TableCell>
                        <TableCell padding="checkbox"  className={classes.tblContentCell} sx={{width:100}}>{val.disc1}</TableCell>
                        <TableCell>{val.qty}
                        </TableCell>
                        <TableCell className={classes.tblContentCell} sx={{width:100}}>{parseFloat(val.gstAmt).toFixed(2)}</TableCell>
                        <TableCell className={classes.tblContentCell} sx={{width:100}}>{parseFloat(val.totalAmt).toFixed(2)}</TableCell>
                        <TableCell className={classes.tblContentCell} sx={{width:100}}>
                            <IconButton  onClick={()=>handleDeleteRow(val, index)}><Delete sx={{color:'red', fontSize:18}}/></IconButton></TableCell>
                        </TableRow>
                        ))}
                        <TableRow className={classes.tablrow} ref={(ref)=>{
                        if (codeRef.current) {
                            ref?.scrollIntoView({ behavior: "smooth", block: "center" });
                        }  
                        }}>
                        <TableCell  padding="checkbox" className={classes.tblContentCell} sx={{borderLeft:'0.5px solid  #ccc'}}>{data.length + 1}</TableCell>
                        <TableCell  padding="checkbox" sx={{ width: 120 }} className={classes.tblContentCell}>
                        <TextField 
                            inputRef={codeRef}
                            size='small'
                            value={code}
                            onChange={handleCodeChange}
                            onKeyPress={handleCodeKeyPress}
                        />               
                        </TableCell>
                        <TableCell variant="body" className={classes.tblContentCell}/>
                        <TableCell padding="checkbox" className={classes.tblContentCell} sx={{width:100}}/>
                        <TableCell padding="checkbox" className={classes.tblContentCell} sx={{width:100}}/>
                        <TableCell padding="checkbox" className={classes.tblContentCell} sx={{width:100}}/>
                        <TableCell padding="checkbox" sx={{ width: 120 }}  className={classes.tblContentCell}/>
                        <TableCell className={classes.tblContentCell} sx={{width:100}}/>
                        <TableCell className={classes.tblContentCell} sx={{width:100}}/>
                        <TableCell className={classes.tblContentCell} sx={{width:100}}/>
                        <TableCell className={classes.tblContentCell} sx={{width:100}}><IconButton onClick={clearNew}><Delete sx={{color:'red', fontSize:18}}/></IconButton></TableCell>
                        </TableRow>
                    
                    </TableBody>
                    </Table>
                </TableContainer>
                <Loader isLoader={isLoader}/>
            </Grid>
            <Grid sx={{justifyContent:"end",marginTop:"20px",display:"flex"}}>
                <Button variant="contained" onClick={onSubmit}>Transfer</Button>
            </Grid>
        </Fragment>
    );
}

export default OtToOtTransfer;
// import axios from 'axios';
// import React, { Fragment, useEffect, useRef, useState } from 'react';
// import { useDispatch } from 'react-redux';
// import { setSnackbar } from '../../../../../components/hooks/snackBar/reducers';
// import { Helmet } from 'react-helmet-async';
// import { Autocomplete, Button, Grid, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from '@mui/material';
// import { useStyle } from '../style';
// import _ from 'lodash';
// import Loader from '../../../../../components/loader/loader';
// import { Delete } from '@mui/icons-material';
// import moment from 'moment';
// import { setPDFData } from '../../../../../components/hooks/printPdf/pdfData';
// import { useNavigate } from 'react-router-dom';
// import { onPressButton, setThermalData } from '../../../../../components/hooks/printPdf/thermalData';

// const OtToOtTransfer = () => {
//     const classes = useStyle()
//     const navigate = useNavigate()
//     const dispatch = useDispatch();
//     const [data, setData] = useState([]);
//     const [outlet, setOutlet] = useState([]);
//     const [code, setCode] = useState("");
//     const codeRef = useRef(null);
//     const [endCode, setEndCode] = useState('')
//     const [itemData, setItemData] = useState(null)
//     const[cust, setCust] = useState(null)
//     const roleId = localStorage.getItem("role_id")

//     const outlet_id = localStorage.getItem('outlet_id')
//     const userID = localStorage.getItem('userId')
//     const [editingIndex, setEditingIndex] = useState(null);
//     const [isLoader, setIsLoader] = useState(false); //loader
//     const [options, setOptions] = useState({
//         fromOutlet: null,
//         toOutlet: null
//     });
//     const [postData, setPostData] = useState({
//         docdate: moment().format('YYYY-MM-DD'),
//         status: "",
//         user_id: userID,
//         outletid: outlet_id,
//         amount: "",
//         subtotal_amount: "",
//         gst_per: 0,
//         gst_amt: "",
//         cess_per: 0,
//         cess_amt: "",
//         roff: "",
//         is_credit: 1,
//         company_id: 1,
//         gst_in: "",
//         outlet_to_outlet_details: [],
//       });
//       let totalAmt=0
//       totalAmt += data.reduce((accumulator, item) => accumulator + parseFloat(item.totalAmt), 0);
//       let gstAmt=0
//       gstAmt += data.reduce((accumulator, item) => accumulator + parseFloat(item.gstAmt), 0);
//       let cessAmt=0
//       cessAmt += data.reduce((accumulator, item) => accumulator + parseFloat(item.cessAmt), 0);
//       let netTotal = 0
//       // netTotal = parseFloat(totalAmt + gstAmt + cessAmt).toFixed(2)
//       netTotal = parseFloat(totalAmt + gstAmt ).toFixed(2)
//     // function getOutletData() {
//     //     axios
//     //         .get("/v1/outlet/list/1")
//     //         .then((res) => {
//     //             setOutlet(res.data);
//     //         })
//     //         .catch((err) => {
//     //             dispatch(setSnackbar(true, "error", err.response.data.error));
//     //         });
//     // }
//     const outletName = localStorage.getItem('outlet_name');

//     const filteredSupplier = outlet.filter(outlet => outlet.fullname === outletName);

//     const units = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
//     const teens = ['Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
//     const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
//     const thousands = ['', 'Thousand', 'Million', 'Billion', 'Trillion'];
  
//     const convertNumber = (num) => {
//       if (num === 0) return 'Zero';
  
//       let words = '';
//       for (let i = 0; num > 0; i++) {
//         if (num % 1000 !== 0) {
//           words = convertHundreds(num % 1000) + ' ' + thousands[i] + ' ' + words;
//         }
//         num = Math.floor(num / 1000);
//       }
//       return words.trim();
//     };
  
//     const convertHundreds = (num) => {
//       if (num >= 100) {
//         return units[Math.floor(num / 100)] + ' Hundred ' + convertTens(num % 100);
//       } else {
//         return convertTens(num);
//       }
//     };
  
//     const convertTens = (num) => {
//       if (num < 10) return units[num];
//       else if (num < 20) return teens[num - 10];
//       else return tens[Math.floor(num / 10)] + ' ' + units[num % 10];
//     };
//     function getOutletData() {
//         axios
//             .get("/v1/outlet/list/1")
//             .then((res) => {
//                 setOutlet(res.data);
    
//                 // Find and prefill the outlet matching the logged-in branch
//                 const loggedInOutlet = res.data.find((outlet) => outlet.id === parseInt(outlet_id));
//                 if (loggedInOutlet) {
//                     setOptions((prevOptions) => ({
//                         ...prevOptions,
//                         fromOutlet: loggedInOutlet,
//                     }));
//                     setCust(loggedInOutlet); // Set the customer info if needed
//                 }
//             })
//             .catch((err) => {
//                 dispatch(setSnackbar(true, "error", err.response.data.error));
//             });
//     }
    
//     function handleOptions(value, name) {
//         let newOptions = { ...options, [name]: value };

//         if (newOptions.fromOutlet && newOptions.toOutlet && newOptions.fromOutlet.id === newOptions.toOutlet.id) {
//             newOptions = { ...newOptions, toOutlet: null };
//         }

//         setOptions(newOptions);
//         console.log(name, value);
//     }
//     function getSelectedRow(e){
//         setEditingIndex(e)
//        } 
//        const handleDeleteRow=(e, index)=>{
//           console.log(e,index)
//           const updatedData = data.filter((_, i) => i !== index);
//           setData(updatedData);
//       }
//       const handleCodeChange = (e) =>{
//         // setCode(e.target.value)
//         setCode(e.target.value.toUpperCase());

//     }
//     const getItemCode = (id) =>{
//         setIsLoader(true)
//         axios.get(`/v1/itemdetails/barcode/${id}/${outlet_id}`)
//         .then(res=>{
//           setIsLoader(false)
//           setItemData(res.data)
//           setEndCode(id)
//           // setRateData((prevData) => ({ ...prevData, mrp: res.data.mrp, rate: res.data.sale_rate, gst : res.data.gst, disc : res.data.discount, qty: 1 }));
//           const objData = {
//             code: code,
//             barcode_to : id,
//             qty: 1,
//             mrp1: res.data.mrp,
//             pro_name: res.data.pro_name,
//             rate1: res.data.sale_rate,
//             gst1: res.data.gst,
//             disc1: res.data.discount,
//             gstAmt:parseFloat((res.data.mrp - res.data.mrp * res.data.discount / 100) * (res.data.gst / 100) * 1).toFixed(2),
//             cessAmt: parseFloat((res.data.sale_rate - res.data.sale_rate * res.data.discount / 100) * (res.data.cess / 100) * 1).toFixed(2),
//             totalAmt: parseFloat((res.data.sale_rate - res.data.sale_rate * res.data.discount / 100) * 1).toFixed(2),
//             ...res.data
//         }
//         const existingItemIndex = data.findIndex((item) => item.code === objData.code && (item.mrp1 === objData.mrp || item.mrp1 === objData.mrp1));
//         const arr = [...data]       
//         setData([])
//         setCode("")
//         if (existingItemIndex !== -1) {
//         // If the item exists, update its quantity, gst, cess, total
//           // arr[existingItemIndex].qty = parseFloat(arr[existingItemIndex].qty) + parseFloat(objData.qty);    
//           // arr[existingItemIndex].barcode_to = parseFloat(arr[existingItemIndex].barcode_to ) + parseFloat(objData.qty)
//           // arr[existingItemIndex].gstAmt = (parseFloat(arr[existingItemIndex].rate1)-parseFloat(arr[existingItemIndex].rate1) * parseFloat(arr[existingItemIndex].disc1 / 100)) * (parseFloat(arr[existingItemIndex].gst1  / 100))* parseFloat(arr[existingItemIndex].qty);    
//           // arr[existingItemIndex].cessAmt = (parseFloat(arr[existingItemIndex].rate1)-parseFloat(arr[existingItemIndex].rate1) * parseFloat(arr[existingItemIndex].disc1 / 100)) * (parseFloat(arr[existingItemIndex].cess / 100))* parseFloat(arr[existingItemIndex].qty);    
//           // arr[existingItemIndex].totalAmt = (parseFloat(arr[existingItemIndex].rate1)-parseFloat(arr[existingItemIndex].rate1) * parseFloat(arr[existingItemIndex].disc1 / 100)) * parseFloat(arr[existingItemIndex].qty);  
//           dispatch(setSnackbar(true, 'error', 'Barcode already exists!'))
//           setData(arr)
//         } else {
//         // If the item doesn't exist, add it to the 'data' array
//           arr.push(objData)
//           setData(arr)
//           setCode("")
//         }
//         codeRef.current.focus()
//         })
//         .catch(err=>{
//           setIsLoader(false)
//           console.log(err.response.data.errors[0].message)
//           dispatch(setSnackbar(true , "error" ,err.response.data.errors[0].message ))
//         })
//       }
//       const clearNew = () =>{
//         console.log("first")
//       }
//     const handleCodeKeyPress = (e) =>{
//         if(e.key === "Enter" && code!==''){
//             getItemCode(code)
//         }
//     }
//     useEffect(() => {
//         getOutletData();
//     }, []);

//     const filteredToOutletOptions = outlet.filter(o => o.id !== (options.fromOutlet ? options.fromOutlet.id : null));
// // const onSubmit = () => {
// //     if(options.fromOutlet == null ){
// //         dispatch(setSnackbar(true , "error" , "Please Select From outlet "))
// //     }else if(options.toOutlet == null){
// //         dispatch(setSnackbar(true , "error" , "Please Select To outlet "))
// //     }else if(data.length == 0){
// //         dispatch(setSnackbar(true , "error" , "Please Scan the barcode in table"))
// //     }else{
// //         console.log("postData",postData)
// //         axios.post(`/v1/outlet_to_outlet_transfer` , postData)
// //         .then((res) => {
// //             console.log(res)
// //             dispatch(setSnackbar(true,'success', 'Outlet transfer successfully!'))
// //             fetchBill()
// //             setData([])
// //             setOptions((prev) => ({...prev , fromOutlet:null , toOutlet:null}))
// //         })
// //         .catch((err) => {
// //             console.log(err)
// //             dispatch(setSnackbar(true , "error" , err.response.data.errors[0].message))
// //         })
// //     }
// // }

// const onSubmit = () => {
//   if (options.fromOutlet == null) {
//       dispatch(setSnackbar(true, "error", "Please Select From outlet"));
//   } else if (options.toOutlet == null) {
//       dispatch(setSnackbar(true, "error", "Please Select To outlet"));
//   } else if (data.length == 0) {
//       dispatch(setSnackbar(true, "error", "Please Scan the barcode in table"));
//   } else {
//       console.log("postData", postData);
//       axios.post(`/v1/outlet_to_outlet_transfer`, postData)
//           .then((res) => {
//               console.log(res);
//               const { docno } = res.data; // Extract docno from the response
//               dispatch(setSnackbar(true, 'success', 'Outlet transfer successfully!'));
//               fetchBill(docno); // Pass the docno to fetchBill
//               setData([]);
//               setOptions((prev) => ({ ...prev, fromOutlet: null, toOutlet: null }));
//           })
//           .catch((err) => {
//               console.log(err);
//               dispatch(setSnackbar(true, "error", err.response.data.errors[0].message));
//           });
//   }
// };

// function fetchBill(docno) {
//   // axios.post(`/v1/outlet_to_outlet_transfer/getall`, { "docno": docno })
//   axios.post('/v1/outlet_to_outlet_transfer/getall', { "docno": docno }, {
//     headers: {
//         'Content-Type': 'application/json'
//     }
// })
//       .then((res) => {
//           console.log(res);
//           dispatch(setPDFData({
//               tableData: tableData,
//               TotalData: TotalData,
//               companyInfo: res.data,
//               docno:docno,
              
//               totalText: convertNumber(Math.round(netTotal)),
//               title: postData.mode === "Transfer" ? "Delivery Challan" : "Outlet Transfer Report"
       
//             }));
//                     // dispatch(onPressButton());
            
//           const name = `BillNo_${docno}`;
//           console.log(`Navigating to: /otTransfer/${name}`,"otTransferotTransfer");
//           navigate(`/otTransfer/${name}`);
          
//           console.log(docno,"dsdfwaefrwname");
          
//       })
//       .catch((err) => {
//           console.log(err);
//           dispatch(setSnackbar(true, 'error', err.response.data.errors[0].message));
//       });
// }

// const tableData = data.map(val=>({
//     pro_name: val.pro_name,
//     hsn:val.hsn,
//     sale_rate:val.sale_rate,
//     pur_rate:val.pur_rate,
//     qty:val.qty,
//     disc1:val.disc1,
//     cgstPerc:val.gst,
//     cgstAmnt : val.gstAmt,
//     totalAmt:val.totalAmt,
//    mode:val.mode,
//    barcode:val.barcode,
//    pro_code:val.pro_code,
   
//   }))
//   console.log(data,"datacheck")
//   console.log(postData,"postdata")
//   const TotalData = {
//     // cess_amt:cessAmt,
//     sub_total: totalAmt,
//     gst:gstAmt,
//     totalAmount:parseFloat(Math.round(netTotal)).toFixed(0),
//     roundOff:(parseFloat(Math.round(netTotal).toFixed(0) -netTotal).toFixed(0)),
//     totalText : convertNumber(Math.round(netTotal)),
//   }
//   // function fetchBill(){
//   //   axios.post(`/v1/sales_master/getall`,{"docno":docName})
//   //   .then((res) => {
//   //     console.log(res);
//   //       dispatch(setPDFData({
//   //         tableData:tableData,
//   //         TotalData:TotalData,
//   //         companyInfo:res.data,  
//   //         totalText : convertNumber(Math.round(netTotal)),
//   //         title : postData.mode === "Transfer" ? "Delivery Challan" : "Outlet Transfer Report"
//   //       }))
//   //       const name = `BillNo_${docName}`
//   //      navigate(`/otTransfer/${name}`)  
      
//   //   })
//   //   .catch((err) => {console.log(err);dispatch(setSnackbar(true,'error',err.response.data.errors[0].message))})
//   // }


// useEffect(() => {
//     if(data.length > 0){
//       let arr=[]
//       data.map(val=>{
//         const obj = {
//           docdate:moment().format('YYYY-MM-DD'),
//           from_outlet_id:options.fromOutlet != null ? options.fromOutlet.id :null,
//           to_outlet_id:options.toOutlet != null ? options.toOutlet.id : null,
//           pro_code:val.pro_code,
//           balance:val.balance,
//           opng_stock:val.op_stk,
//           balnc_stock:1,
//           prodid:val.id,
//           dis_per:val.disc1,
//           dis_amt:parseFloat((val.rate1 -(val.rate1 * (100 - val.disc1 )/ 100)) * val.qty).toFixed(2),
//           mrp:val.mrp1,
//           rate:val.rate1,
//           qty:val.qty,
//           gst_per:val.gst1,
//           gst_amt:val.gstAmt,
//           cess_per:val.cess,
//           cess_amt:val.cessAmt,
//           company_id:1,
//           barcode:  val.barcode,
//           head_id: val.head_id ,
//           type_id:  val.type ,
//           subcat_id:  val.sub_cat ,
//           cat_id:  val.cat_id ,
//           uom_id:  val.uom ,
//           outletid: outlet_id
//         }
//         arr.push(obj)
//       })
//       setPostData((prevState)=>({...prevState,outlet_to_outlet_details: arr ,
//         from_outlet_id:options.fromOutlet != null ? options.fromOutlet.id : null,
//         to_outlet_id: options.toOutlet != null ? options.toOutlet.id : null,
//         amount: Math.round(parseFloat(netTotal)),
//         subtotal_amount:totalAmt ,
//         gst_amt:parseFloat(gstAmt).toFixed(2),
//         cess_amt:cessAmt,
//         roff:(Math.round(netTotal).toFixed(2) -netTotal),
//     }))
//     }
      
//     },[data,options])
//     console.log('From Outlet:', options.fromOutlet);
//     console.log('To Outlet:', options.toOutlet);
//     console.log(data)
//     console.log(postData)
//     return (
//         <Fragment>
//             <Helmet><title>OT to OT Transfer</title></Helmet>
//             <Typography variant="h6">OT to OT Transfer</Typography>
//             <Grid container spacing={2}>
//                 <Grid item xs={12} sm={6} md={4}>
//                     <Typography sx={{ marginBlockEnd: "20px", fontWeight: "bold" }}>From Outlet</Typography>
//                     {roleId == 2 || roleId == 1 ? 
                    
//                     <Autocomplete
//                     size="small"
//                     value={options.fromOutlet}
                   
//                     options={outlet}
//                     // options={filteredSupplier} 

//                     disableClearable
//                     onChange={(e, value) => handleOptions(value, 'fromOutlet')}
//                     getOptionLabel={option => option.fullname}
//                     renderInput={(params) => <TextField {...params} label="Select Outlet" />}
//                     isOptionEqualToValue={(option, value) => option.id === value.id} 
//                 />
                    
//                     :
                    
//                     <Autocomplete
//                     size="small"
//                     value={options.fromOutlet}
                   
//                     // options={outlet}
//                     options={filteredSupplier} 

//                     disableClearable
//                     onChange={(e, value) => handleOptions(value, 'fromOutlet')}
//                     getOptionLabel={option => option.fullname}
//                     renderInput={(params) => <TextField {...params} label="Select Outlet" />}
//                     isOptionEqualToValue={(option, value) => option.id === value.id} 
//                 />
                    
//                     }
                
//                 </Grid>
//                 <Grid item xs={12} sm={6} md={4}>
//                     <Typography sx={{ marginBlockEnd: "20px", fontWeight: "bold" }}>To Outlet</Typography>
//                     <Autocomplete
//                         size="small"
//                         value={options.toOutlet}
//                         options={filteredToOutletOptions}
//                         disableClearable
//                         onChange={(e, value) => handleOptions(value, 'toOutlet')}
//                         getOptionLabel={option => option.fullname}
//                         renderInput={(params) => <TextField {...params} label="Select Outlet" />}
//                         disabled={!options.fromOutlet} 
//                         isOptionEqualToValue={(option, value) => option.id === value.id} 
//                     />
//                 </Grid>
//             </Grid>
//             <Grid className="w-full " sx={{height:"350px",overflow:"auto",marginTop:"30px"}}>
//                 <TableContainer className={classes.tblRoot}>
//                     <Table stickyHeader  className={classes.table}>
//                     <TableHead className={classes.tblHeader} sx={{position: "sticky",top: 0,}}>
//                         <TableRow className={classes.tablrow}>
//                         <TableCell className={classes.tblCell} sx={{borderLeft:'0.5px solid  #ccc'}}>Sno</TableCell>
//                         <TableCell className={classes.tblCell} sx={{minWidth:"150px"}}>Barcode</TableCell>
//                         <TableCell className={classes.tblCell} sx={{minWidth:"150px"}}>Product Name</TableCell>
//                         <TableCell className={classes.tblCell}>MRP</TableCell>
//                         <TableCell className={classes.tblCell}>GST%</TableCell>
//                         <TableCell className={classes.tblCell}>Rate</TableCell>
//                         <TableCell className={classes.tblCell}>Dis%</TableCell>
//                         <TableCell className={classes.tblCell}>Qty</TableCell>
//                         <TableCell className={classes.tblCell}>GST</TableCell>
//                         <TableCell className={classes.tblCell}>Amount</TableCell>
//                         <TableCell className={classes.tblCell}>Action</TableCell>
//                         </TableRow>
//                     </TableHead>
//                     <TableBody>
//                         {_.map(data, (val, index) => (
//                         <TableRow className={classes.tablrow} key={index} onClick={() => getSelectedRow(index)}>
//                         <TableCell  padding="checkbox" className={classes.tblContentCell} sx={{borderLeft:'0.5px solid  #ccc'}}>{index + 1}</TableCell>
//                         <TableCell>{val.code}</TableCell>
//                         <TableCell variant="body" className={classes.tblContentCell}>{val.pro_name}</TableCell>
//                         <TableCell padding="checkbox" className={classes.tblContentCell} sx={{width:100}}>{val.mrp1}</TableCell>
//                         <TableCell padding="checkbox"  className={classes.tblContentCell} sx={{width:100}}>{val.gst1}</TableCell>
//                         <TableCell padding="checkbox"  className={classes.tblContentCell} sx={{width:100}}>{val.rate1}</TableCell>
//                         <TableCell padding="checkbox"  className={classes.tblContentCell} sx={{width:100}}>{val.disc1}</TableCell>
//                         <TableCell>{val.qty}
//                         </TableCell>
//                         <TableCell className={classes.tblContentCell} sx={{width:100}}>{parseFloat(val.gstAmt).toFixed(2)}</TableCell>
//                         <TableCell className={classes.tblContentCell} sx={{width:100}}>{parseFloat(val.totalAmt).toFixed(2)}</TableCell>
//                         <TableCell className={classes.tblContentCell} sx={{width:100}}>
//                             <IconButton  onClick={()=>handleDeleteRow(val, index)}><Delete sx={{color:'red', fontSize:18}}/></IconButton></TableCell>
//                         </TableRow>
//                         ))}
//                         <TableRow className={classes.tablrow} ref={(ref)=>{
//                         if (codeRef.current) {
//                             ref?.scrollIntoView({ behavior: "smooth", block: "center" });
//                         }  
//                         }}>
//                         <TableCell  padding="checkbox" className={classes.tblContentCell} sx={{borderLeft:'0.5px solid  #ccc'}}>{data.length + 1}</TableCell>
//                         <TableCell  padding="checkbox" sx={{ width: 120 }} className={classes.tblContentCell}>
//                         <TextField 
//                             inputRef={codeRef}
//                             size='small'
//                             value={code}
//                             onChange={handleCodeChange}
//                             onKeyPress={handleCodeKeyPress}
//                         />               
//                         </TableCell>
//                         <TableCell variant="body" className={classes.tblContentCell}/>
//                         <TableCell padding="checkbox" className={classes.tblContentCell} sx={{width:100}}/>
//                         <TableCell padding="checkbox" className={classes.tblContentCell} sx={{width:100}}/>
//                         <TableCell padding="checkbox" className={classes.tblContentCell} sx={{width:100}}/>
//                         <TableCell padding="checkbox" sx={{ width: 120 }}  className={classes.tblContentCell}/>
//                         <TableCell className={classes.tblContentCell} sx={{width:100}}/>
//                         <TableCell className={classes.tblContentCell} sx={{width:100}}/>
//                         <TableCell className={classes.tblContentCell} sx={{width:100}}/>
//                         <TableCell className={classes.tblContentCell} sx={{width:100}}><IconButton onClick={clearNew}><Delete sx={{color:'red', fontSize:18}}/></IconButton></TableCell>
//                         </TableRow>
                    
//                     </TableBody>
//                     </Table>
//                 </TableContainer>
//                 <Loader isLoader={isLoader}/>
//             </Grid>
//             <Grid sx={{justifyContent:"end",marginTop:"20px",display:"flex"}}>
//                 <Button variant="contained" onClick={onSubmit}>Transfer</Button>
//             </Grid>
//         </Fragment>
//     );
// }

// export default OtToOtTransfer;
